(() => {
  const initialize = (root) => {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    root.querySelectorAll('table').forEach(table => {
      const headings = [...table.querySelectorAll('thead th')].map(cell => cell.textContent.trim());
      table.querySelectorAll('tbody tr').forEach(row => [...row.cells].forEach((cell,index) => { cell.dataset.label = headings[index] || ''; }));
    });
  };
  document.querySelectorAll('[data-cs-application-schema]').forEach(initialize);
  document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('[data-cs-application-schema]').forEach(initialize));
})();
